<template>
    <div 
        v-if="$validateText(text)" 
        ref="container"
        class="tooltip-html-container"
        tabindex="-1"
        @blur="(e) => onBlur(e)"
    >
        <div
            v-tooltip="{
                content: text,
                trigger: 'manual',
                show: show,
                container: false,
                popperOptions: {
                    positionFixed: true,
                }
            }" 
            class="tooltip-wrapper"
            @click="toggleTooltip()"
        >
            <slot>
                <i class="fa-regular fa-info-circle tooltip-icon" />  
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        toggleTooltip() {
            this.show = !this.show;
        },
        onBlur(e) {
            if (!this.$refs.container.contains(e.relatedTarget)) {
                this.show = false;
            }
        }
    }
};
</script>